/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API } from '../../../api';

export interface IArticleData {
  [key: string]: any;
  articleId: string;
  orgId: string;
  groups: string[];
  articleName: string;
  type: string;
  coverImageUrl: string;
  fileUrl: string;
  authorName: string;
  authorId: string;
  createdBy?: string;
  readTime: string;
  accessFor: string;
  tags: string[];
  industries: string[];
  topics: string;
  articleDescription: string;
  embeddedLinks:string;
  approved: boolean;
  upVotes: number;
  downVotes: number;
  views: number;
  isPublished: boolean;
  allowedGroup: boolean;
  createdAt: number;
  __v: number;
  isVoted: boolean;
  isViewed: boolean;
  location: any;
}

export interface IArticle {
  ArticleList: IArticleData[];
  total: number;
}

interface IInitialState {
  loading: boolean;
  data: IArticle | undefined;
  error: boolean;
  errorText: string;
}

const initialState: IInitialState = {
  loading: false,
  data: undefined,
  error: false,
  errorText: ''
};
export const fetchAllArticlesUser = createAsyncThunk(
  'getAllArticleUser',
  async ({ orgId, tags, type, industries, helpSettings, useCache }: { orgId: string; tags: string[]; type: string[]; industries: string[] ; helpSettings : boolean ; useCache?: boolean}) => {
    try {
      const response = await API.getAllArticleUser({ orgId, tags, type, industries , helpSettings, useCache});
      // console.log(response , " ==>")
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const getAllArticleUserSlice = createSlice({
  name: 'get all articles user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllArticlesUser.pending, (state: IInitialState) => {
        state.loading = true;
        state.error = false;
        state.errorText = '';
        state.data = undefined;
      })
      .addCase(fetchAllArticlesUser.fulfilled, (state: IInitialState, action) => {
        state.loading = false;
        state.error = false;
        state.errorText = '';
        state.data = action?.payload?.data as IArticle;
      })
      .addCase(fetchAllArticlesUser.rejected, (state: IInitialState, action) => {
        state.loading = false;
        state.error = true;
        // console.error(action.error);
        state.errorText = action.error.message || 'Something went wrong';
        state.data = undefined;
      });
  }
});

export const articleActions = getAllArticleUserSlice.actions;

export default getAllArticleUserSlice.reducer;
